import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Location } from '@angular/common';

import { PrivacyEducationArticle } from '../../../../common/models/privacy/PrivacyEducationArticle.model';
import { ConnectDataPrivacyService } from '../../../../common/services/requests/connect-data-privacy/connect-data-privacy.service';
import { PrivacyActionsService } from '../../privacyActions.service';
import { PrivacyService } from '../../../../common/services/process/privacy/privacy.service';
import { TranslateService } from '@ngx-translate/core';
import { ValuesService } from '../../../../common/values/values.service';
import { ModalRoutelessService } from '../../../../common/components/ui/ui-modal-routeless/modal.routeless.service';
import { LanguageService } from '../../../../common/services/core/language.service';
import { MessageService } from '../../../../common/services/core/message.service';
import { PrivacyEvents, PrivacyValuesService } from '../../../../common/values/privacy.values.service';
import { OutletsStatusService, Outlet, OutletStatus } from '../../../../common/services/core/outlets.status.service';

@Component({
    selector: 'app-privacy-education-article',
    templateUrl: './privacy-education-article.component.html',
    styleUrls: ['./../privacy-education.component.scss'],
    host: {
        '[class.dashboard-body]': 'true'
    }
})
export class PrivacyEducationArticleComponent implements OnInit, OnDestroy, AfterViewInit {

    article: PrivacyEducationArticle;
    articleID: string;
    onDestroy$: Subject<void> = new Subject<void>();
    currentLang = '';
    activeFilter = this.privacyActionsService.selectedCategoryForEducation;
    errorState = false;

    constructor(
        private readonly connectDataPrivacyService: ConnectDataPrivacyService,
        private readonly location                 : Location,
        private readonly privacyActionsService    : PrivacyActionsService,
        private readonly route                    : ActivatedRoute,
        private readonly privacyService           : PrivacyService,
        private readonly messageService           : MessageService,
        private readonly modalRoutelessService    : ModalRoutelessService,
        private readonly translateService         : TranslateService,
        private readonly valuesService            : ValuesService,
        private readonly router                   : Router,
        public readonly privacyValuesService      : PrivacyValuesService,
        private readonly languageService          : LanguageService,
        private readonly outletsStatusService: OutletsStatusService
    ) {
        this.translateService.onLangChange
        .pipe(takeUntil(this.onDestroy$))
        .subscribe( () => {
            this.start();
        });
    }

    ngOnInit() {
        if (this.privacyService.getParkedIdentityStatus()) {
            this.messageService.sendMessage(PrivacyEvents.PARKED_IDENTITY, {parkedIdentity: true, modalType: this.modalRoutelessService.getIsModalOpened()});
            return;
        }

        this.start();
    }

    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    ngAfterViewInit(): void {
        this.outletsStatusService.setStatus(Outlet.PAGE, OutletStatus.DONE);
    }

    start() {
        this.articleID = this.route.snapshot.paramMap.get('articleID');
        this.currentLang = this.languageService.getLang();
        this.connectDataPrivacyService.getEducationArticles([this.articleID], this.currentLang)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe({
                next: res => {
                    if (!res) {
                        throw res;
                    }
                    if(res.length === 0) {
                        this.navigateToEducation();
                    }
                    this.article = res[0];
                },
                error: err => {
                    this.privacyService.checkParkedIdentity(err, false);
                    this.errorState = true;
                }
            });
    }

    navigateToEducation() {
        this.router.navigate([this.valuesService.centralPaths.privacy.path.concat(this.valuesService.centralPaths.privacy.education.path)]);
    }

    goBack() {
        //! am nevoie pentru back-ul care duce pe /privacy/activity sa se ataseze in coada url-ului '#'+this.article.topic
        // pentru restul merge:
        this.location.back();
    }

}
